import axios from 'axios';
import debounce from 'lodash/debounce';

import { cartHelpers } from '../mixins/cartHelpers';
import { freeShipping } from '../mixins/freeShipping';
import { retailStoreData } from '../mixins/retailStoreData';

export default {
  name: 'cart',
  components: {},
  mixins: [cartHelpers, freeShipping, retailStoreData],
  props: [],
  data() {
    return {
      isPickUpSelected: false,
      cart: {
        items: [],
        total_price: 0,
      },
      locations: [
        {
          title: 'test location',
          address: '1234 E 1st Ave Space 123',
          city: 'test, UT 12345',
          hours: [
            'Mon - Thu | 11AM - 8PM',
            'Fri - Sat | 11AM - 9PM',
            'Sun | 11AM - 6PM',
          ],
          id: 123456789,
        },
      ],
      userLocation: {
        address: '',
        searchDistance: 30,
        lat: null,
        lon: null,
        hasSearchedForStores: false,
      },
      addressInput: '', // real time value of the user input, before the debouncer is accounted for.
      debounedInput: '', //input that has made it past the debounce timer
      placesQueryPredictions: null, //results from the places prediction API, trying to guess the address of user input.
      hideLocationPredictions: true,
      distanceSelector: '50',
      selectedLocationInventory: {},
      hasUserSelectedLocation: false,
    };
  },
  computed: {
    fitleredLocations() {
      let filteredLocations = this.locations;

      //limit down to only the available pickup locations. (could do this when locations are first picked up.)
      filteredLocations = filteredLocations.filter(
        (loc) => loc.isPickupLocation === true
      );

      //limit by distance.
      filteredLocations = filteredLocations.filter(
        (loc) =>
          this.calculateDistance(
            this.userLocation.lat,
            this.userLocation.lon,
            loc.lat,
            loc.lon
          ) <= parseInt(this.distanceSelector)
      );

      return filteredLocations;
    },
  },
  methods: {
    setPickupOption(isSelected) {
      this.isPickUpSelected = isSelected;
    },
    updateItem(id, quantity) {
      if (id === 40511363612733) {
        // donation item
        //if we already have the donation item, we should remove it.
        if (this.cartContainsDonationCheckboxItem()) {
          vueSideCart.updateItem(id, 0, false);
          return;
        }
      } else if (id === 39947795988541) {
        // route insurance item
        //if we already have the insurance item, we should remove it.
        if (this.cartContainsRouteInsuranceItem()) {
          vueSideCart.updateItem(id, 0, false);
          return;
        }
      }
      //update the item.
      vueSideCart.updateItem(id, quantity, false);
    },

    getLocations() {
      //just get all location for now.
      axios
        .get(
          `https://development-access-api.cotopaxi.com/location/getLocations`
        )
        .then((response) => {
          this.locations = response.data;

          this.locations.forEach((l) => {
            l.isSelected = false;
          });

          //merge our location metadata with the data from shopify. (mixin function)
          this.locations = this.combineShopifyLocationDataWithAdditionalData(
            this.locations
          );
        })
        .catch((error) => {
          //console.log(error);
        });
    },
    getSelectedLocationInventory(location) {
      // deselect other locations.
      this.locations.forEach((l) => {
        l.isSelected = false;
      });
      //now set the clicked location to is selected.
      location.isSelected = true;

      //get the list of variant ids together so that we can go grab the inventory.
      let cartVariantIds = '';
      this.cart.items.forEach((item) => {
        cartVariantIds += item.id + ',';
      });
      //get the location specific inventory for the item in the cart.
      axios
        .get(
          `https://development-access-api.cotopaxi.com/inventory/getInventoryByLocationIdAndVariantId/${location.id}/${cartVariantIds}`
        )
        .then((response) => {
          this.selectedLocationInventory = response.data;
          this.hasUserSelectedLocation = true;
        })
        .catch((error) => {
          //console.log(error);
        });
    },
    clearSelectedLocation() {
      this.locations.forEach((l) => {
        l.isSelected = false;
      });
    },
    selectedLocationHasInventoryForVariantId(variantId) {
      //hide out of stock info block when the user hasn't done the input.
      if (!this.hasUserSelectedLocation || this.isPickUpSelected == false) {
        return true;
      }
      //find the matching inventory data.
      let variantLocationInventory = this.selectedLocationInventory.find(
        (sli) => sli.variantId === variantId
      );
      //if we found a match, return true is available. If we didn't match, there is not inventory at that location.
      return variantLocationInventory
        ? variantLocationInventory.available > 0
        : false;
    },

    showMissingInventoryWarning() {
      //if the user has not selected a location, this can't be true.
      if (!this.hasUserSelectedLocation) {
        //console.log('return first');
        return false;
      }

      //if we find an item without inventory, false
      for (let item of this.cart.items) {
        if (!this.selectedLocationHasInventoryForVariantId(item.id)) {
          //console.log('return middle');
          return true;
        }
      }
      //console.log('return end');
      //if we didn't find any problems, this is true.
      return false;
    },

    findStores() {
      this.getGeolocationData(encodeURIComponent(this.addressInput));
    },

    getPredictionsWithDebounce: debounce(function () {
      //if nothing has changed, don't do another search.
      if (this.debouncedInput === this.addressInput) {
        return;
      }
      //Also, don't search on 0 input.
      if (this.addressInput == '') {
        this.clearSelectedLocation();
        return;
      }
      //since the user is chaning their address input, lets clear out any location they've previously selected.
      this.clearSelectedLocation();
      this.debouncedInput = this.addressInput;
      this.hideLocationPredictions = false;
      //send a string to prediction API, callback for the follow up to the response.
      this.getInputQueryPredictions(this.debouncedInput);
    }, 500), //500ms delay
    predictionClicked(prediction) {
      this.addressInput = prediction.description;
      this.debouncedInput = this.addressInput;
      this.hideLocationPredictions = true;
      this.findStores();
    },

    getInputQueryPredictions(searchString) {
      //if the search string is empty or null, lets not do a search.
      if (!searchString) {
        return;
      }
      axios
        .get(
          'https://maps.googleapis.com/maps/api/place/autocomplete/json?input=' +
            encodeURIComponent(searchString) +
            '&key='
        )
        .then((response) => {
          if (response.data.predictions.length > 0) {
            this.placesQueryPredictions = response.data.predictions;
            //console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);
          } else {
            console.error('No predictions for the given search.');
          }
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
    },

    getGeolocationData(address) {
      //console.log(address);
      axios
        .get(
          'https://maps.googleapis.com/maps/api/geocode/json?address=' +
            address +
            '&key='
        )
        .then((response) => {
          if (response.data.results.length > 0) {
            let geoCodingData = response.data.results[0].geometry.location;
            this.userLocation.lat = geoCodingData.lat;
            this.userLocation.lon = geoCodingData.lng;
            this.userLocation.hasSearchedForStores = true;
            //console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);
          } else {
            console.error('Invalid address or zip code.');
          }
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
    },

    calculateDistance(lat1, lon1, lat2, lon2) {
      // console.log('distance calc:');
      // console.log(lat1, lon1, lat2, lon2);

      const R = 3958.8; // Radius of the Earth in miles
      const dLat = this.toRadians(lat2 - lat1);
      const dLon = this.toRadians(lon2 - lon1);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.toRadians(lat1)) *
          Math.cos(this.toRadians(lat2)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = R * c; // Distance in miles
      return distance.toFixed(1);
    },
    // used to calc distance in miles to pick up locations.
    toRadians(degrees) {
      return degrees * (Math.PI / 180);
    },
  },
  mounted() {
    // remove this comment once we turn BOPIS on
    //this.getLocations();

    //listen to the sidecart for changes to the cart state. keeps the cart page up to date with the sidecart
    vueSideCart.eventEmitter.on('requestComplete', (cart) => {
      //remove this console.log when you're done. This is just so you can see the object in the dev console to work with it.
      //console.log('Event triggered with data:', cart);
      //do whatever you need with the cart object here
      this.cart = cart;
    });
  },
};
